import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'removeleadingzeros' })
export class RemoveLeadingZerosPipe implements PipeTransform {
	transform(value: string): any {
		if (!value) return value;
		return value.replace(/^[0]+/g, "");
	}
}